<template>
    <b-card no-body class="nsp-card">
        <b-card-header class="d-flex align-items-center">
            <span class="nsp-title">{{ $t('NSP_VENTILATION') }}</span>
        </b-card-header>

        <b-card-body>
            <div class="d-flex align-items-center">
                <span>{{ $t('NSP_RECUP') }}</span>
                <b-badge class="ml-auto" :variant="vent.running ? 'success' : 'secondary'">
                    {{ vent.running ? $t('NSP_RUNNING') : $t('NSP_STOPPED') }}
                </b-badge>
            </div>

            <div class="text-muted small mt-2 mb-2">{{ $t('NSP_WHY_RUNNING') }}</div>

            <ul class="nsp-reasons">
                <li v-for="reason in reasons" :key="reason.key" :class="{ active: reason.active }">
                    <i class="icon-check" v-if="reason.active"></i>
                    <i class="icon-close" v-else></i>
                    {{ reason.label }}
                </li>
            </ul>

            <hr class="my-3"/>

            <div class="d-flex align-items-center">
                <span>{{ $t('NSP_EXHAUST_BOOSTER') }}</span>
                <b-badge class="ml-auto" :variant="vent.exhaustBooster ? 'success' : 'secondary'">
                    {{ vent.exhaustBooster ? $t('NSP_FULL_SPEED') : $t('NSP_STOPPED') }}
                </b-badge>
            </div>
            <div class="text-muted small mt-1">{{ $t('NSP_EXHAUST_HINT') }}</div>

            <hr class="my-3"/>

            <div class="text-muted small mb-1">{{ $t('NSP_VENT_PERIODS') }}</div>
            <div>
                <b-badge v-for="(period, index) in vent.period" :key="index" variant="light" class="mr-2">
                    {{ period.start }} - {{ period.end }}
                </b-badge>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
// reason keys as produced by NSPanel.ventState() on the server. They explain the
// recuperator only, which runs at full flow or not at all. The extra extract fan
// has a single reason of its own, a bathroom light, and is shown separately so
// the two are not read as one.
const REASON_KEYS = [
    { key: 'user', label: 'NSP_REASON_USER' },
    { key: 'bathroomOne', label: 'NSP_REASON_BATHROOM_ONE' },
    { key: 'bathroomTwo', label: 'NSP_REASON_BATHROOM_TWO' },
    { key: 'period', label: 'NSP_REASON_PERIOD' },
    { key: 'ac', label: 'NSP_REASON_AC' },
];

export default
{
    name: 'VentilationCard',
    props:
    {
        vent:
        {
            type: Object,
            required: true,
        },
    },
    computed:
    {
        reasons()
        {
            const me = this;
            const active = me.vent.reasons || [];

            return REASON_KEYS.map((reason) => (
                {
                    key: reason.key,
                    label: me.$t(reason.label),
                    active: (active.indexOf(reason.key) !== -1),
                }));
        },
    },
};
</script>
